import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';

import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {EntitlementsFilters} from 'src/modules/entitlements/typedef';

export const userDatasetEntitlementsStateSlice = getCachedTableStateSlice<
    undefined,
    undefined,
    EntitlementsFilters
>('userDatasetEntitlementsState', undefined);

export const userDatasetEntitlementsStateActions = userDatasetEntitlementsStateSlice.actions;
export const userDatasetEntitlementsStateSelector: CachedTableStateSelector<
    undefined,
    undefined,
    EntitlementsFilters
> = state => state.userPage.tabs.userEntitlements.dataset.state;
